import { VirtualAgent } from "@/components/VirtualAgent/VirtualAgent";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BaseCase() {
  return <VirtualAgent name="Foo" />;
}

function BoldCase() {
  return <VirtualAgent bold name="Foo" />;
}

export function PlaygroundVirtualAgentTag() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic</PlaygroundSubSectionTitle>
        <BaseCase />
      </PlaygroundSubSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Bold</PlaygroundSubSectionTitle>
        <BoldCase />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
